import React from "react";
import { node, string } from "prop-types";
import GridTable from "pages/_components/GridTable/GridTable";
import FormattedDate from "pages/_components/FormattedDate";
import CustomData from "pages/_components/CustomData/CustomData";
import FormattedAmount from "pages/_components/FormattedAmount";

const FirmasEcheck = ({ data, curency }) => (
    <GridTable.Container columns={3} columnsTemplate="fixed">
        <GridTable.Data>
            <GridTable.Container>
                <GridTable.Data>
                    <CustomData
                        titleText="echecks.endorse.dateTime"
                        titleTextType="I18N"
                        valueText={<FormattedDate date={data?.aval_fecha} dateFormat="DD/MM/YYYY HH:mm:ss" />}
                        valueTextType="TEXT"
                    />
                </GridTable.Data>
            </GridTable.Container>
        </GridTable.Data>
        <GridTable.Data>
            <GridTable.Container>
                <CustomData
                    titleText="echecks.document.aval.detail"
                    titleTextType="I18N"
                    valueText={
                        data?.aval_documento && data?.aval_documento_tipo
                            ? `${data?.aval_documento_tipo} ${data?.aval_documento}`
                            : "N/A"
                    }
                    valueTextType="TEXT"
                />
            </GridTable.Container>
        </GridTable.Data>
        <GridTable.Data>
            <GridTable.Container>
                <GridTable.Data>
                    <CustomData
                        titleText="echeq.avalista.nombre"
                        titleTextType="I18N"
                        valueText={data?.aval_razon_social ? data?.aval_razon_social : "N/A"}
                        valueTextType="TEXT"
                    />
                </GridTable.Data>
            </GridTable.Container>
        </GridTable.Data>

        <GridTable.Data>
            <GridTable.Container>
                <GridTable.Data>
                    <CustomData
                        titleText="echek.aval.caracter"
                        titleTextType="I18N"
                        valueText={data?.aval_caracter ? data?.aval_caracter : "N/A"}
                        valueTextType="TEXT"
                    />
                </GridTable.Data>
            </GridTable.Container>
        </GridTable.Data>
        <GridTable.Data>
            <GridTable.Container>
                <GridTable.Data>
                    <CustomData
                        titleText="echecks.aval.adress.label"
                        titleTextType="I18N"
                        valueText={data?.aval_domicilio ? data?.aval_domicilio : "N/A"}
                        valueTextType="TEXT"
                    />
                </GridTable.Data>
            </GridTable.Container>
        </GridTable.Data>
        <GridTable.Data>
            <GridTable.Container>
                <GridTable.Data>
                    <CustomData
                        titleText="echeq.aval.importe.avalado"
                        titleTextType="I18N"
                        valueText={
                            <FormattedAmount
                                className="data-label"
                                currency={curency}
                                quantity={data?.aval_importe_avalado}
                            />
                        }
                    />
                </GridTable.Data>
            </GridTable.Container>
        </GridTable.Data>

        <GridTable.Data>
            <GridTable.Container>
                <GridTable.Data>
                    <CustomData
                        titleText="echeq.avalado.nombre"
                        titleTextType="I18N"
                        valueText={data?.aval_sujeto_avalado ? data?.aval_sujeto_avalado : "N/A"}
                        valueTextType="TEXT"
                    />
                </GridTable.Data>
            </GridTable.Container>
        </GridTable.Data>
    </GridTable.Container>
);

FirmasEcheck.propTypes = {
    data: node.isRequired,
    curency: string.isRequired,
};

export default FirmasEcheck;
